// Central brand identity. Every customer-facing surface should read brand
// name/tagline from here rather than hardcoding copy, so a rename only
// needs to change here.
//
// Logo assets live in public/brand/ (served as static files, not bundled —
// appropriate for a logo that rarely changes and may be referenced outside
// the JS bundle, e.g. a <link rel="icon">). See FitMapLogo.tsx for how
// variant/surface map to these files.

export const BRAND = {
  name: 'FitMap',
  tagline: 'Find your fit across brands.',
  logo: {
    horizontal: {
      light: '/brand/fitmap-logo-light.svg',
      dark: '/brand/fitmap-logo-dark.svg',
    },
    icon: {
      // Icon-only mark is only provided pre-baked for light surfaces today;
      // FitMapLogo falls back to an inline badge for icon+dark.
      light: '/brand/fitmap-mark.svg',
    },
    png: '/brand/fitmap-logo.png',
  },
} as const;
